import React, { Component } from 'react';
import LoaderComponent from '../components/common/LoaderComponent';
import envConfig from '../../static/config';
import UserManagementStore from '../stores/UserManagementStore';
import FavouritesStore from '../stores/AccountsStore/FavouritesStore';
import UserManagementActionCreator from '../actions/UserManagementActionCreator';
import FavouritesActionCreator from '../actions/AccountsActionCreator/FavouritesActionCreator';

function getState() {
  return {
    ready:
      UserManagementStore.getUserDetailsLoad() && FavouritesStore.getLoad(),
    isLargeCustomer: FavouritesStore.isLargeCustomer(),
    isSMEUser: UserManagementStore.isSMEUser(),
  };
}

export function withLCV(WrappedComponent) {
  class WithLCV extends Component {
    constructor(props) {
      super(props);
      this.onStoreChange = this.onStoreChange.bind(this);
      this.state = getState();
    }

    componentDidMount() {
      UserManagementStore.addChangeListener(this.onStoreChange);
      FavouritesStore.addChangeListener(this.onStoreChange);

      if (!UserManagementStore.getUserDetailsLoad()) {
        UserManagementActionCreator.getUserDetails();
      }

      if (!FavouritesStore.getLoad()) {
        FavouritesActionCreator.getFavouriteAccounts();
      }
    }

    componentWillUnmount() {
      FavouritesStore.removeChangeListener(this.onStoreChange);
      UserManagementStore.removeChangeListener(this.onStoreChange);
    }

    onStoreChange() {
      this.setState(getState());
    }

    render() {
      const { ready, isLargeCustomer, isSMEUser } = this.state;

      return ready ? (
        <WrappedComponent
          {...this.props}
          largeCustomerEnabled={Boolean(
            isLargeCustomer && isSMEUser && envConfig.isLcvEnabled
          )}
        />
      ) : (
        <LoaderComponent type="large" />
      );
    }
  }

  WithLCV.displayName = `withLCV(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithLCV;
}
